import type { PostHog } from "posthog-js";
import type { FeatureFlags } from "../FeatureFlags";

export class PosthogFeatureFlags implements FeatureFlags<unknown> {
  private readonly posthog: PostHog;

  constructor(posthog: PostHog) {
    this.posthog = posthog;
  }

  isFeatureEnabled(feature: string): boolean {
    return this.posthog.isFeatureEnabled(feature) ?? false;
  }

  onFeatureFlagsUpdated(callback: () => void): void {
    this.posthog.onFeatureFlags(() => callback());
  }
}
